/** Default landing route based on evaluated role permissions */
export const getHomePath = (permissions) => {
  if (permissions?.analytics?.dashboard?.view === true) return "/crm";
  return "/crm/appointments/dashboard";
};

export default getHomePath;
